import React, { useState } from "react";
import { Link } from "react-router-dom";
import apiService from "../Common/Configurations/APIService";
import config from "../Common/Configurations/APIConfig";
import DefaultData from "../CompanyData/DefaultData";

const features = [
    { icon: 'ri-flight-takeoff-line', name: 'Flights' }, 
    { icon: 'ri-building-line', name: 'Hotels' },
    { icon: 'ri-car-line', name: 'Cars' }, 
    { icon: 'ri-bus-2-line', name: 'Bus' },
    { icon: 'ri-suitcase-line', name: 'Holidays' }, 
    { icon: 'ri-visa-line', name: 'Visas' },
    { icon: 'ri-magic-line', name: 'AI Packages' }, 
    { icon: 'ri-whatsapp-line', name: 'AI Chatbot' },
    { icon: 'ri-user-add-line', name: 'Leads' }, 
    { icon: 'ri-global-line', name: 'Website' },
    { icon: 'ri-bar-chart-line', name: 'Analytics' }, 
    { icon: 'ri-calculator-line', name: 'Accounting' }, // Added Smart Accounting
    { icon: 'ri-customer-service-2-line', name: 'Support' },
];

// Reusable left-side marketing component
const MarketingSide = () => (
     <div className="col-lg-7 text-center text-lg-start mb-5 mb-lg-0">
                                <h1 className="display-6 fw-bolder mb-3" style={{ color: DefaultData.THEMECOLOR3 }}>{DefaultData.LANDINGPAGETITLE}</h1>
                                <p className="fs-5 mb-5" style={{ color: DefaultData.THEMECOLOR3, opacity: 0.9 }}>{DefaultData.LANDINGPAGESUBTITLE}</p>
                                 <div className="row row-cols-3 row-cols-md-4 row-cols-lg-5 justify-content-center g-4">
                                                                {features.map((feature) => (
                                                                    <div className="col" key={feature.name}>
                                                                        <div className="text-center">
                                                                            <div 
                                                                                className="shadow-sm"
                                                                                style={{ 
                                                                                    width: '70px', 
                                                                                    height: '70px', 
                                                                                    borderRadius: '50%', 
                                                                                    backgroundColor: DefaultData.THEMECOLOR3, 
                                                                                    display: 'flex', 
                                                                                    alignItems: 'center', 
                                                                                    justifyContent: 'center', 
                                                                                    color: DefaultData.THEMECOLOR2, // Changed to ThemeColor1 for contrast inside white circle 
                                                                                    marginBottom: '0.5rem', 
                                                                                    margin: '0 auto' 
                                                                                }}
                                                                            >
                                                                                <i className={`${feature.icon} fs-2`}></i>
                                                                            </div>
                                                                            <span className="fw-medium" style={{ color: DefaultData.THEMECOLOR3 }}>{feature.name}</span>
                                                                        </div>
                                                                        </div>
                                                                ))}
                                                            </div>
                            </div>
);


export default function ForgotPassword() {
    const [values, setValues] = useState({ email: "" });
    const [errors, setErrors] = useState({});
    const [btnSubmit, setBtnSubmit] = useState(false);
    const [showSuccessPage, setShowSuccessPage] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues((prev) => ({ ...prev, [name]: value }));
        if (errors.email === false) setErrors({});
    };

    const validate = () => {
        let temp = {};
        temp.email = values.email !== "" && /\S+@\S+\.\S+/.test(values.email);
        setErrors(temp);
        return temp.email;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            setBtnSubmit(true);
            const formData = {
                email: values.email,
                domainUrl: window.location.origin,
            };
            try {
                await apiService.post(config.SENDRESETLINK, formData);
                setShowSuccessPage(true);
            } catch (error) {
                console.error("Reset failed:", error);
                setErrors({ submit: error?.response?.data?.message || "Failed to send reset link. Please try again." });
            } finally {
                setBtnSubmit(false);
            }
        }
    };
    
    const applyErrorClass = (field) => (field in errors && errors[field] === false ? " is-invalid" : "");

    return (
        <div style={{ backgroundColor: DefaultData.THEMECOLOR1 }}>
            <main className="container-fluid d-flex align-items-center" style={{ minHeight: '100vh' }}>
                <div className="container">
                    <div className="row align-items-center justify-content-center">

                        <MarketingSide />

                        <div className="col-lg-5 d-flex justify-content-center justify-content-lg-end">
                            <div className="card shadow-lg border-0" style={{ borderRadius: '1rem', width: '100%', maxWidth: '450px' }}>
                                <div className="card-body p-lg-5 p-4">
                                    
                                    {/* Conditionally render the form or the success message */}
                                    {showSuccessPage ? (
                                        <div className="text-center">
                                            <div className="mb-4 text-success">
                                                <i className="ri-mail-send-fill" style={{ fontSize: '64px' }}></i>
                                            </div>
                                            <h4 className="fw-bold">Check Your Email</h4>
                                            <p className="text-muted">We've sent a password reset link to <strong>{values.email}</strong>.</p>
                                            <div className="mt-4">
                                                <Link to="/" className="btn w-100 fw-bold" style={{ backgroundColor: DefaultData.THEMECOLOR1, color: DefaultData.THEMECOLOR4 }}>
                                                    Return to Sign In
                                                </Link>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="text-center mb-4">
                                                <img src="/assets/images/Zotrai.png" alt={`${DefaultData.DEFAULTBRANDNAME} Logo`} style={{ height: '35px' }} />
                                            </div>
                                            <h4 className="fw-bold text-center">Forgot Password?</h4>
                                            <p className="text-muted text-center mb-4">Enter your email and we'll send you a reset link.</p>
                                            
                                            {errors.submit && <div className="alert alert-danger">{errors.submit}</div>}

                                            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                                                <div className="mb-3">
                                                    <label htmlFor="email" className="form-label">Email</label>
                                                    <input
                                                        className={`form-control form-control-lg ${applyErrorClass("email")}`}
                                                        name="email"
                                                        type="text"
                                                        value={values.email}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter your registered email"
                                                    />
                                                    {errors.email === false && (
                                                        <div className="invalid-feedback d-block">Please enter a valid email.</div>
                                                    )}
                                                </div>
                                                <div className="mt-4">
                                                    <button type="submit" className="btn btn-lg w-100 fw-bold" style={{ backgroundColor: DefaultData.THEMECOLOR1, color: DefaultData.THEMECOLOR2 }} disabled={btnSubmit}>
                                                        {btnSubmit ? "Sending Link..." : "Send Reset Link"}
                                                    </button>
                                                </div>
                                                <div className="mt-4 text-center">
                                                    <Link to="/" className="small text-decoration-none" style={{ color: DefaultData.THEMECOLOR2 }}>
                                                        <i className="ri-arrow-left-line align-middle"></i> Back to Sign In
                                                    </Link>
                                                </div>
                                            </form>
                                        </>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}